import * as Joi from 'joi';

const submitRequest = Joi.object({
  approver: Joi.number().required().messages({
    'any.required': `Approver cannot be empty`,
  }),
  reason: Joi.string().trim().min(1).max(255).required().messages({
    'any.required': `Reason is not allowed to be empty`,
    'string.max': `Exceed the maximum character`,
  }),
});

export default submitRequest;
